module.exports = __webpack_public_path__ + "img/checkbox-unchecked.e513b71c.svg";